import { MASTER_RECORD_TYPE_NAME } from '@server/parser';

export const getRecordTypeIdentifier = (recordTypeName: string | null, objectName: string) =>
  `${objectName}.${recordTypeName ?? MASTER_RECORD_TYPE_NAME}`;
